export default __webpack_public_path__ + "static/media/arrowGreen.4b23a14e.svg";